import { Modal, Button } from "react-bootstrap"
import { Dispatch, SetStateAction, useCallback } from "react"
import { endpointsCf } from "../../../../config/componentsConfig"
import useFetchWithMsal from "../../../../hooks/useFetchWithMsal"

interface DeleteFileModalProps {
  show: {show: boolean, item: any};
  setShow: Dispatch<SetStateAction<{show: boolean, item: any}>>;
  page: string;
  selectedMode: string;
  setSelectedFiles: Dispatch<SetStateAction<never[]>>;
  setFiles: Dispatch<SetStateAction<never[]>>;
  setSummaryExiste: Dispatch<SetStateAction<Map<string, boolean>>>;
}

const DeleteFileModal: React.FC<DeleteFileModalProps> = ({ show, setShow, deleteFile, page, selectedMode, setSelectedFiles, setFiles, setSummaryExiste }) => {

    const { execute, isLoading} = useFetchWithMsal();

    const handleFileDelete = useCallback(async () => {
    
        if (selectedMode !== "MYGEORGES") return;
        
        try {
          await execute("POST", endpointsCf.delete, {
            fileId: show.item.id,
            fileName: show.item.name,
            page: page,
            selectedMode: selectedMode
          });
          
          // Supprimer le fichier de la liste des fichiers sélectionnés
          setSelectedFiles(prev => prev.filter(id => id !== show.item.id));
          
          // Supprimer le fichier de la liste des fichiers
          setFiles(prevFiles => {
            const removeFile = (items) => {
              return items.reduce((acc, file) => {
                if (file.id === show.item.id) {
                  return acc;
                }
                if (file.type === 'folder' && file.children) {
                  return [...acc, {
                    ...file,
                    children: removeFile(file.children)
                  }];
                }
                return [...acc, file];
              }, []);
            };
            
            return removeFile(prevFiles);
          });
    
          // Supprimer le fichier de la Map summaryExiste
          setSummaryExiste(prev => {
            const newMap = new Map(prev);
            newMap.delete(show.item.id);
            return newMap;
          });

          setShow({show: false, item: null});
          
        } catch (err) {
          console.error('Delete error:', err);
        }
      }, [execute, page, show.show, show.item, selectedMode, setSelectedFiles, setFiles, setSummaryExiste, setShow]);


    return(
        <Modal show={show.show} onHide={() => setShow({show: false, item: null})}>
            <Modal.Header closeButton>
                <Modal.Title>Delete File</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading ? <p>Deleting...</p> : <p>Are you sure you want to delete this file?</p>}    
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow({show: false, item: null})}>Cancel</Button>
                <Button variant="danger" onClick={handleFileDelete}>Delete</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteFileModal;   